
  export const QUOTES_RECEIVED = "QUOTES_RECEIVED";
  export const SET_QUOTE = "SET_QUOTE";
  export const CREATE_QUOTE = "CREATE_QUOTE";
  export const SET_PROPERTY_QUOTE = "SET_PROPERTY_QUOTE";
  